import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

const Documents = ({match}) => (
  <div className="app-wrapper">
    <Switch>
      <Route path={`${match.url}/manuals`} component={asyncComponent(() => import('./routes/Manuals/index'))}/>
      <Route path={`${match.url}/templates`} component={asyncComponent(() => import('./routes/Templates/index'))}/>
       <Route path={`${match.url}/otherfiles`} component={asyncComponent(() => import('./routes/OtherFiles/index'))}/>
       <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
    </Switch>
  </div>
);

export default Documents;